import { StyledExtensionIframeSalesforce } from "app/pages/sales-intelligence/services/extension/style";
import { useExtensionIframe } from "app/pages/sales-intelligence/services/extension/useExtensionIframe";
import { SidebarTrackingSectionName } from "app/pages/sales-intelligence/sub-modules/right-sidebar/components/Sidebar/SidebarContainer";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const SfConvertPage = () => {
    const domain = proNavigator.getParams()?.key as string;
    const { iframeProps } = useExtensionIframe({
        domain,
        urlParams: { mode: "salesforce", trackingSectionName: SidebarTrackingSectionName.SFConnector },
    });

    return iframeProps ? <StyledExtensionIframeSalesforce {...iframeProps} /> : null;
};
